module.exports = __webpack_public_path__ + "assets/img/check-circle@1,5x.d97a9ad6.svg";